<template>
  <el-dialog
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="提现设置"
  >
    <el-form
      ref="params"
      :model="params"
      :rules="paramsRules"
      label-width="auto"
    >
      <el-form-item label="自动提现">
        <el-checkbox v-model="checked" @change="openAuto"
          >开启自动提现</el-checkbox
        >
      </el-form-item>
      <div v-if="mode !== 'no'">
        <el-form-item label="提现方式">
          {{ way }}
        </el-form-item>
      </div>
      <div v-if="mode === 'no'">
        <el-form-item label="提现方式">
          <el-radio-group v-model="chargeType">
            <el-radio-button label="1">微信</el-radio-button>
            <el-radio-button label="2">银行卡</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div v-if="chargeType === '1'">
          <el-form-item label="微信号绑定">
            <img v-if="imgShow" :src="img" alt="微信绑定二维码" />
            <div>二维码在1分钟内有效,请快速绑定</div>
          </el-form-item>
        </div>
        <div v-if="chargeType === '2'">
          <el-form-item label="所属行" prop="bankId">
            <el-select v-model="params.bankId" placeholder="请选择所属行">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.value"
                :value="item.num"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="持卡人姓名" prop="name">
            <el-input v-model="params.name" />
          </el-form-item>
          <el-form-item label="输入银行卡号" prop="cardNum">
            <el-input v-model="params.cardNum" maxlength="30" />
          </el-form-item>
          <el-form-item label="确认银行卡号" prop="cardNumTwo">
            <el-input v-model="params.cardNumTwo" maxlength="30" />
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取消</el-button>
      <el-button type="primary" @click="post">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import agentGetBindWeChatSCode from "@/api/user/agent-manage/agentGetBindWeChatSCode";
import QRCode from "qrcode";
import bankList from "@/utils/bankList";
import agentBindBankCard from "@/api/user/agent-manage/agentBindBankCard";
import agentEnableAutoWithdrawMoney from "@/api/user/agent-manage/agentEnableAutoWithdrawMoney";
import agentDisableAutoWithdrawMoney from "@/api/user/agent-manage/agentDisableAutoWithdrawMoney";
import { Message } from "element-ui";

export default {
  name: "withdrawSetDialogOld",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    bankNum: String,
    mode: String,
    autoWithdraw: Number,
  },
  computed: {
    way() {
      if (this.mode === "card") {
        return `银行卡:${this.bankNum}   如需更改请联系管理员`;
      } else if (this.mode === "weChat") {
        return "微信账户   如需更改请联系管理员";
      } else {
        return "";
      }
    },
  },
  watch: {
    autoWithdraw: {
      handler(value) {
        this.checked = value === 1;
      },
      immediate: true,
      deep: true,
    },
    dialog(value) {
      if (value === true) {
        this.bind();
        this.interval = setInterval(() => {
          this.bind();
        }, 58000);
      } else {
        if (this.intercal === undefined) {
          clearTimeout(this.interval);
        }
      }
    },
  },
  data() {
    return {
      interval: undefined,
      options: bankList,
      chargeType: "1",
      params: {
        name: undefined,
        cardNum: undefined,
        cardNumTwo: undefined,
        bankId: undefined,
      },
      imgShow: false,
      img: undefined,
      checked: false,
      withdrawSetForm: {
        day: undefined,
      },
      paramsRules: {
        day: [{ type: "number", message: "必须为数字值" }],
        bankId: [
          {
            required: true,
            message: "请输入所属行",
          },
        ],
        name: [
          { required: true, message: "请输入持卡人姓名" },
          { max: 4, message: "不支持对公" },
        ],
        cardNum: [
          {
            required: true,
            message: "请输入银行卡号",
          },
        ],
        cardNumTwo: [{ required: true, message: "请再次输入银行卡号" }],
      },
    };
  },
  methods: {
    openAuto(newV) {
      if (newV === true) {
        agentEnableAutoWithdrawMoney().then((res) => {
          this.resDispose({
            res,
          });
        });
      } else if (newV === false) {
        agentDisableAutoWithdrawMoney().then((res) => {
          this.resDispose({
            res,
          });
        });
      }
    },
    bind() {
      agentGetBindWeChatSCode().then((res) => {
        let url = `${process.env.VUE_APP_WE_URL}/BindOperators?agentCode=${res.data.agentCode}&bindCode=${res.data.code}`;
        QRCode.toDataURL(url).then((qt) => {
          this.img = qt;
          this.imgShow = true;
        });
      });
    },
    post() {
      if (this.chargeType === "2") {
        this.$refs["params"].validate((valid) => {
          if (valid) {
            if (this.params.cardNumTwo !== this.params.cardNum) {
              Message({
                message: "两次银行卡号不一致",
                type: "error",
                duration: 3 * 1000,
              });
              return;
            }
            delete this.params.card;
            agentBindBankCard(this.params).then((res) => {
              this.resEditNoDialog({ res });
            });
          }
        });
      }
    },
  },
};
</script>
